import router from "../../router/index";
import axios from "axios";

export const auth = {
  namespaced: true,
  state: {
    loggedIn: null,
  },
  actions: {
    async login(context, payload) {
      const response = await axios.post(
        "https://api.rightcloud.pl/auth/local",
        payload
      );
      const responseData = await response;
      if (responseData.status !== 200) {
        const error = new Error(
          responseData.message ||
            "Failed to add new employee. Please try again later."
        );
        throw error;
      }
      if (responseData.status === 200) {
        context.commit("setUser", responseData.data);
        localStorage.setItem("user", JSON.stringify(responseData.data));
        router.push("/dashboard/default").catch(error => console.log(error));
      }
    },
    async tryLogin(context) {
      let userToken = JSON.parse(localStorage.getItem("user"));
      const validation = await axios.get("https://api.rightcloud.pl/users/me", {
        headers: {
          Authorization: `Bearer ${userToken.jwt}`,
        },
      });
      const validationResponse = await validation
      if(validationResponse.status === 200){
          console.log(validationResponse.data)
          context.commit("setUser", validation.data)
          router.push("/dashboard/default").catch(error => console.log(error))
      } else{
        console.log('running')
        localStorage.removeItem('user')
      }
    },
    logOut(context){
      localStorage.removeItem('user')
      context.commit('logOut')
      router.push("/auth/login")
    }
  },
  mutations: {
    setUser(state, payload) {
      state.loggedIn = payload;
      // router.push("/dashboard/default").catch(error => console.log(error));
    },
    logOut(state){
      state.loggedIn = null;
    }
  },
  getters: {
    isAdmin(state) {
      return state.loggedIn.admin;
    },
    isLogged(state){
      return state.loggedIn
    }
  },
};
